import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import styles from "./style.module.scss";
import { Icons } from "assets";
import CustomButton from "shared/components/customButton";
import { toastMessage } from "shared/components/toast";
import { rejectBookAudioService } from "shared/services/hodService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";
import Loader from "shared/components/loader/animation";
import { Rating } from "@mui/material";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface RejectBookAudioRevisionProps {
  open: boolean;
  handleClose: any;
  selectedBook: any;
  isRating?: boolean;
}

export default function RejectBookAudioRevision({
  open,
  handleClose,
  selectedBook,
  isRating,
}: RejectBookAudioRevisionProps) {
  const [reason, setReason] = useState<string>("");
  const { user } = useSelector((state: any) => state.root);
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);
  const [bookRating, setBookRating] = useState<any>(0);

  const onClose = () => {
    handleClose();
    setReason("");
    setBookRating(0);
  };

  const handleSubmit = () => {
    if (isRating && bookRating === 0) {
      toastMessage("error", "Please put ratings.");
      return;
    }
    if (!reason.trim()) {
      toastMessage("error", "Please add a reason.");
      return;
    }

    const data: any = {
      book_id: selectedBook?.id,
      feedback: {
        rating: isRating ? { value: bookRating } : null,
        intial_review: null,
        detailed_review: null,
        reject_reason: reason,
      },
      reason: reason,
      rating: isRating ? bookRating : undefined,
      comment: "",
    };

    setLoader(true);
    rejectBookAudioService(data)
      .then(({ data }) => {
        toastMessage("success", data?.message);
        onClose();
        navigate(routeConstant.dashboard.path);
        setLoader(false);
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.message);
        console.log("err", err?.response?.data?.message);
        setLoader(false);
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
      >
        <DialogContent sx={{ padding: "50px" }}>
          <Icons.CrossIcon className={styles.crossIcon} onClick={handleClose} />

          <div className={styles.title}>Reason for rejection</div>

          <textarea
            className={styles.textarea}
            value={reason}
            placeholder="Add reason"
            onChange={(e) => setReason(e.target.value)}
          />

          {isRating && (
            <div className={styles.ratingContainer}>
              <div className={styles.title}>Rating</div>

              <Rating
                name="simple-controlled"
                value={bookRating}
                onChange={(event, newValue) => {
                  setBookRating(newValue);
                }}
                max={10}
              />
            </div>
          )}

          <CustomButton
            text="Submit"
            buttonStyle={styles.btn}
            handleClick={handleSubmit}
          />

          {loader && <Loader />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
